import { create } from 'zustand';
import { BatchExtractionData } from '../types/invoiceTypes';

type ViewMode = 'upload' | 'results';

interface InvoiceState {
  viewMode: ViewMode;
  batchResult: BatchExtractionData | null;
  error: string | null;

  // Actions
  setViewMode: (mode: ViewMode) => void;
  setBatchResult: (data: BatchExtractionData | null) => void;
  setError: (error: string | null) => void;
  clearResults: () => void;
  resetToUpload: () => void;
}

export const useAppInvoiceStore = create<InvoiceState>((set) => ({
  // Initial state
  viewMode: 'upload',
  batchResult: null,
  error: null,

  // Actions
  setViewMode: (mode) => set({ viewMode: mode }),

  setBatchResult: (data) => set({ batchResult: data }),

  setError: (error) => set({ error }),

  // Clear results when new files are selected
  clearResults: () => set({
    batchResult: null,
    error: null,
    viewMode: 'upload',
  }),

  // Reset to upload view (when user clicks back button)
  resetToUpload: () => set({
    viewMode: 'upload',
    error: null,
    // Keep batchResult so user can go back to results if needed
  }),
}));
